import { Menu } from "@opencode/ui/menu"
import { createContext, useContext, type Accessor, type ComponentProps, type ParentProps } from "solid-js"

const SidebarMenuRoot = createContext<Accessor<HTMLElement | undefined>>()

export function SidebarMenuProvider(props: ParentProps<{ root: Accessor<HTMLElement | undefined> }>) {
  return <SidebarMenuRoot.Provider value={props.root}>{props.children}</SidebarMenuRoot.Provider>
}

export function SidebarMenuPortal(props: ComponentProps<typeof Menu.Portal>) {
  const root = useContext(SidebarMenuRoot)
  // Collections move between the desktop sidebar and the modal drawer without
  // changing owners. Resolve the DOM destination when each menu portal opens.
  return (
    <Menu.Portal
      {...props}
      mount={root?.()?.closest<HTMLElement>('[data-component="sair-session-drawer"]') ?? props.mount}
    />
  )
}
